import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentWithSchedulesForm } from '@/pages/document-payment-schedules/form';
import { DocumentDirection } from '@repo/database/browser';
import { PROTECTED, DOCUMENT_PAYMENT_SCHEDULES } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${DOCUMENT_PAYMENT_SCHEDULES}`;

export const Route = createFileRoute(
  '/protected/_layout/document-payment-schedules/_layout/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewDocumentPaymentScheduleModal,
});

function NewDocumentPaymentScheduleModal() {
  const search = useSearch({ strict: false }) as { tab?: string };
  const defaultDirection =
    search.tab === 'sale'
      ? DocumentDirection.OUTGOING
      : DocumentDirection.INCOMING;

  return (
    <DocumentWithSchedulesForm
      defaultDirection={defaultDirection}
      returnUrl={RETURN_URL}
    />
  );
}
